import { create } from 'zustand';
import { persist, PersistOptions } from 'zustand/middleware';

type State = {
  token: string | null;
  loading: boolean;
  initialized: boolean;
};

type Action = {
  setServerlessToken: (token: State['token']) => void;
};

type ServerlessStore = State & Action;

type ServerlessPersist = {
  token: string | null;
};

const persistOptions: PersistOptions<ServerlessStore, ServerlessPersist> = {
  name: 'serverless-storage',
  partialize: (state) => ({ token: state.token }),
};

export const useServerlessStore = create<ServerlessStore>()(
  persist(
    (set) => ({
      token: '',
      loading: true,
      initialized: false,
      setServerlessToken: (token) =>
        set(() => ({
          token,
          initialized: true,
          loading: false,
        })),
    }),
    persistOptions
  )
);
